import type { AnyAction } from "redux";
import { swSettings } from "app/common/services/swSettings";
import {
    IS_LOADING_METER_DATA,
    SET_NUMBER_OF_TRACKERS_LIMIT,
    SET_NUMBER_OF_TRACKERS,
    IS_SHARE_TRACKER_MODAL_OPEN,
} from "app/action_types/tracker_module_action_types";

interface ITrackerModuleState {
    numOfTrackerLimitation: number | undefined;
    numOfExistingTrackers: number | undefined;
    isLoadingMeterData: boolean;
    shareTrackerModalIsOpen: boolean;
}

function getDefaultState(): ITrackerModuleState {
    return {
        numOfTrackerLimitation: swSettings?.components?.Home?.resources?.NumAllowedCustomTrackers,
        numOfExistingTrackers: undefined,
        isLoadingMeterData: false,
        shareTrackerModalIsOpen: false,
    };
}

function trackerModule(state: ITrackerModuleState = getDefaultState(), action: AnyAction): ITrackerModuleState {
    switch (action.type) {
        case SET_NUMBER_OF_TRACKERS:
            return {
                ...state,
                numOfExistingTrackers: action.amountOfTrackers,
            };
        case SET_NUMBER_OF_TRACKERS_LIMIT:
            return {
                ...state,
                numOfTrackerLimitation: action.limit,
            };
        case IS_LOADING_METER_DATA:
            return {
                ...state,
                isLoadingMeterData: action.isLoading,
            };
        case IS_SHARE_TRACKER_MODAL_OPEN:
            return {
                ...state,
                shareTrackerModalIsOpen: action.isSharedModalOpen,
            };
        default:
            return state;
    }
}

export default trackerModule;
